<template lang="pug">
w-input.f-email(
  v-bind=`{ value, label, required, validate }`
  ref='input'
  @input='input'
  @change='change'
)
</template>

<script lang="js">
import WInput, { mixin } from '@/widgets/w-input'
import { Logger } from '@/lib/logger'

export const isEmail = value => value && value.match( /[^@]+@[^.]+\..+/ )

export default {
  name: 'EmailField',
  mixins: [ mixin ],
  components: { WInput },
  props: {
    label: {
      type: String,
      default: 'email'
    },
    required: {
      type: Boolean,
      default: true
    },
    filter: Object,
    validate: {
      type: [ Object, Array, Function ],
      default: () => function ( value ) {
        Logger.debug( 'validate email', '<f-email>', {
          value,
          valid: isEmail( value )
        })()
        if ( !isEmail( value )) {
          return 'valid email address required'
        }
      }
      // TODO: add email validation regardless
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.f-email {

}
</style>
